export enum CommissionType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT"
}
